import { Input as NikeInput } from '@nike/frame-component-library';
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

const Input = ({
                   className, errorMessage, id, isDisabled, label, onChange, placeholder, type, value,
               }) => {
    const { localizedBody } = useSelector((state) => state);

    return (
      <article className={className}>
        <p className="body-2 mt2-sm">{label}</p>
        <NikeInput
          id={id}
          isDisabled={isDisabled}
          placeholder={placeholder || localizedBody.RL_Enter}
          type={type}
          value={value}
          onChange={({ target: { value: newValue } }) => onChange(newValue)}
        />
        {errorMessage && <p className="text-color-error body-4 mt1-sm">{errorMessage}</p>}
      </article>
    );
};

Input.defaultProps = {
    className: 'ncss-col-sm-12 ncss-col-md-6 ta-sm-l va-sm-t',
    errorMessage: '',
    id: '',
    isDisabled: false,
    label: '',
    placeholder: '',
    type: 'text',
    value: '',
};

Input.propTypes = {
    className: PropTypes.string,
    errorMessage: PropTypes.string,
    id: PropTypes.string,
    isDisabled: PropTypes.bool,
    label: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    type: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
};

export default Input;
